import { CameraOutlined, PictureOutlined } from '@ant-design/icons';
import { Button, Dropdown } from 'antd';
import { useRef, useState } from 'react';
import { reviewText } from '@/features/inventorization/review-i18n';

export function RegisterPhotoCaptureButton({
  onCapture,
  registerLabel,
}: {
  onCapture: (file: File) => Promise<void> | void;
  registerLabel: string;
}) {
  const inputRef = useRef<HTMLInputElement>(null);
  const galleryInputRef = useRef<HTMLInputElement>(null);
  const [isCapturing, setIsCapturing] = useState(false);

  async function handleFile(file: File | undefined) {
    if (!file) {
      return;
    }

    setIsCapturing(true);

    try {
      await onCapture(file);
    } finally {
      setIsCapturing(false);
    }
  }

  return (
    <>
      <Dropdown
        disabled={isCapturing}
        menu={{
          items: [
            {
              key: 'camera',
              icon: <CameraOutlined />,
              label: reviewText('register.capturePhoto', 'Capture photo'),
              onClick: () => inputRef.current?.click(),
            },
            {
              key: 'gallery',
              icon: <PictureOutlined />,
              label: reviewText('register.chooseFromGallery', 'Choose from gallery'),
              onClick: () => galleryInputRef.current?.click(),
            },
          ],
        }}
        trigger={['click']}
      >
        <Button icon={<CameraOutlined />} loading={isCapturing} type="default">
          {reviewText('register.capturePhoto', 'Capture photo')}
        </Button>
      </Dropdown>
      <input
        accept="image/*"
        aria-label={reviewText('register.capturePhotoFor', 'Capture photo for {register}', {
          register: registerLabel,
        })}
        capture="environment"
        hidden
        onChange={event => {
          const file = event.currentTarget.files?.[0];
          event.currentTarget.value = '';
          void handleFile(file);
        }}
        ref={inputRef}
        type="file"
      />
      <input
        accept="image/*"
        hidden
        onChange={event => {
          const file = event.currentTarget.files?.[0];
          event.currentTarget.value = '';
          void handleFile(file);
        }}
        ref={galleryInputRef}
        type="file"
      />
    </>
  );
}
